import { FC } from "react";
import { Box } from "@mui/material";
import Text from "../../components/Text";
import { useTheme } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import MyAdContent from "./MyAdContent";

const MyAdDeals: FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <>
      <Text
        fontSize={30}
        fontWeight={700}
        color={theme.palette.primary.main}
        className="sticky top-14 z-40"
        style={{
          fontFamily: "Righteous",
          padding: isMobile ? "10px 30px" : "10px 50px",
          background: "#EAF7E6",
        }}
      >
        My Ad Deal
      </Text>
      <Box
        style={{
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          justifyContent: "flex-start",
          padding: isMobile ? "10px 0px 50px 50px" : "30px 50px 50px 50px",
        }}
      >
        <MyAdContent />
      </Box>
    </>
  );
};

export default MyAdDeals;
